import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function tabsInit() {
  const tabsButtons = document.querySelectorAll('.specificationPage__tabs__navButton');
  const tabsBoxes = document.querySelectorAll('.specificationPage__tabs__box');
  let tabWrapper = document.querySelector('.specificationPage__tabs');
  const nav = document.querySelector('.specificationPage__tabs__navWrapper');

  const removeClass = (elements, classToRemove) => {
    elements.forEach(element => {
      (element.classList.contains(classToRemove)) ? element.classList.remove(classToRemove) : '' ;
    });
  }

  tabsButtons.forEach(button=>{
    button.addEventListener('click', ()=>{
      removeClass(tabsButtons, 'active');
      removeClass(tabsBoxes, 'active');
      button.classList.add('active');

      tabsBoxes.forEach(tab => {
        (tab.getAttribute('data-value') == button.getAttribute('data-value')) ? tab.classList.add('active') : '' ;
      })


      ScrollTrigger.refresh(true);
      
    })
  })

  gsap.to(nav, {scrollTrigger: {
    trigger: tabWrapper,
    pin: nav,
    start: 'top 40',
    toggleClass: "pinned",
  }});  
}